/* ATTAR chapters: stacking chapters, drifting photographs, reveals, header, menu, films.
   Everything re-initialises on Theme Editor events, so added, removed or reordered sections work immediately. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const wraps = () => [...document.querySelectorAll('main > .axh-section')];
  const naturalTop = w => {
    const main = document.querySelector('main');
    let y = main.getBoundingClientRect().top + scrollY;
    for (const x of wraps()) { if (x === w) return y; y += x.offsetHeight; }
    return y;
  };
  const goTo = w => w && scrollTo({ top: naturalTop(w), behavior: reduce ? 'auto' : 'smooth' });

  /* chapter lists (header, menu, footer site map) */
  function buildLists() {
    const chapters = [...document.querySelectorAll('[data-axc-chapter]')];
    const item = (c, span, extra = '') => `<a href="#${c.id}"${extra}>${span ? `<span>${esc(c.dataset.axcNum)}</span>` : (c.dataset.axcNum ? esc(c.dataset.axcNum) + '. ' : '')}${esc(c.dataset.axcTitle)}</a>`;
    document.querySelectorAll('[data-axc-index]').forEach(n => n.innerHTML = chapters.map(c => item(c, false)).join(''));
    document.querySelectorAll('[data-axc-menu-chapters]').forEach(n => n.innerHTML = chapters.map(c => item(c, true, ' data-axh-menu-close')).join(''));
    document.querySelectorAll('[data-axc-sitemap]').forEach(n => n.innerHTML = chapters.map(c => `<li>${item(c, false)}</li>`).join(''));
  }

  /* reveal on entering the screen */
  const io = 'IntersectionObserver' in window && !reduce
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0.15 })
    : null;
  function reveal() {
    document.querySelectorAll('[data-axh-reveal]:not(.is-in)').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  }

  /* photographs start loading before their section arrives; curtain and circle reveals hide them from the browser's own lazy loading */
  const eager = el => el.querySelectorAll('img[loading="lazy"]').forEach(i => { i.loading = 'eager'; });
  const pio = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { eager(e.target); pio.unobserve(e.target); } }), { rootMargin: '100% 0px' })
    : null;
  function preload() {
    if (!pio || (window.Shopify && Shopify.designMode)) { eager(document); return; }
    wraps().forEach(w => pio.observe(w));
  }

  /* photographs drift downward while their chapter passes; the covered chapter sinks and darkens */
  let items = [], running = false;
  function collectParallax() {
    items = reduce ? [] : [...document.querySelectorAll('[data-axh-parallax]')].map(img => {
      const s = parseFloat(img.dataset.axhParallax) || 1.2;
      img.style.setProperty('--axh-ps', s);
      return { img, box: img.closest('.axc-media') || img.parentElement, s, cur: null, target: 0 };
    });
  }
  function setTops() {
    wraps().forEach(w => {
      const inner = w.firstElementChild;
      const stick = !reduce && !!inner && inner.dataset.axcStick === 'true';
      w.classList.toggle('axc-stick', stick);
      if (!stick && inner) { inner.style.transform = ''; w.style.setProperty('--axc-dim', 0); }
      w.style.setProperty('--axh-stick', Math.min(0, innerHeight - w.offsetHeight) + 'px');
    });
  }

  /* title letter by letter */
  function letters() {
    document.querySelectorAll('[data-axc-fx="letters"]:not([data-axc-split])').forEach(h => {
      h.dataset.axcSplit = '1';
      h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
      let c = 0;
      const walk = node => {
        [...node.childNodes].forEach(n => {
          if (n.nodeType === 3) {
            const frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(part => {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              const w = document.createElement('span'); w.className = 'axc-w'; w.setAttribute('aria-hidden', 'true');
              [...part].forEach(ch => { const s = document.createElement('span'); s.className = 'axc-ch'; s.style.setProperty('--c', c++); s.textContent = ch; w.appendChild(s); });
              frag.appendChild(w);
            });
            n.replaceWith(frag);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
        });
      };
      walk(h);
    });
  }

  /* 3D tilt on fine pointers */
  const canTilt = !reduce && matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.addEventListener('pointermove', e => {
    if (!canTilt) return;
    const el = e.target.closest && e.target.closest('[data-axc-tilt]');
    document.querySelectorAll('[data-axc-tilt].is-tilt').forEach(x => { if (x !== el) { x.classList.remove('is-tilt'); x.style.setProperty('--rx', '0deg'); x.style.setProperty('--ry', '0deg'); } });
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
    el.classList.add('is-tilt');
    el.style.setProperty('--ry', (px * 7).toFixed(2) + 'deg');
    el.style.setProperty('--rx', (-py * 7).toFixed(2) + 'deg');
  }, { passive: true });

  /* product card sizes: price and "Buy now" follow the chosen size */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-axc-size]');
    if (!b) return;
    const card = b.closest('[data-axc-pcard]');
    card.querySelectorAll('[data-axc-size]').forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    const price = card.querySelector('[data-axc-price]'); if (price) price.textContent = b.dataset.price;
    const buy = card.querySelector('[data-axc-buy]');
    if (buy) {
      buy.href = '/cart/' + b.dataset.id + ':1';
      const ok = b.dataset.available === 'true';
      buy.classList.toggle('is-off', !ok);
      buy.setAttribute('aria-disabled', ok ? 'false' : 'true');
    }
  });
  function frame() {
    const vh = innerHeight;
    let moving = false;
    items.forEach(it => {
      if (!it.img.isConnected) return;
      const r = it.box.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2)));
      it.target = -p * ((it.s - 1) / 2) * r.height;
      if (it.cur === null) it.cur = it.target;
      const d = it.target - it.cur;
      it.cur = Math.abs(d) > 0.3 ? it.cur + d * 0.12 : it.target;
      if (Math.abs(d) > 0.3) moving = true;
      it.img.style.setProperty('--axh-py', it.cur.toFixed(2) + 'px');
    });
    if (!reduce) {
      const ws = wraps();
      ws.forEach((w, i) => {
        const next = ws[i + 1], inner = w.firstElementChild;
        if (!inner || !w.classList.contains('axc-stick')) return;
        const k = next ? Math.max(0, Math.min(1, 1 - next.getBoundingClientRect().top / vh)) : 0;
        inner.style.transform = k ? `scale(${(1 - 0.05 * k).toFixed(4)})` : '';
        w.style.setProperty('--axc-dim', (k * 0.6).toFixed(3));
      });
    }
    if (moving) requestAnimationFrame(frame); else running = false;
  }
  const kick = () => { if (!running) { running = true; requestAnimationFrame(frame); } };

  /* header states */
  function headerState() {
    const h = document.querySelector('[data-axc-header]');
    if (!h) return;
    const opening = document.querySelector('.axc-open');
    h.classList.toggle('is-top', !!opening && scrollY < innerHeight * 0.5);
    // dark header text whenever the area under the header is light (ivory sections, footer)
    const under = document.elementsFromPoint(innerWidth / 2, 40).find(el => !h.contains(el) && el.closest('.axc-tone-ivory, #footer, .axc-foot'));
    h.classList.toggle('is-light', !!under);
  }

  /* films: silent loop, only while visible, pause button */
  const vio = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => {
        const v = e.target;
        if (e.isIntersecting && !v.dataset.userPaused && !reduce) v.play().catch(() => {}); else if (!e.isIntersecting) v.pause();
      }), { threshold: 0.15 })
    : null;
  function films() {
    document.querySelectorAll('[data-axc-video]:not([data-axc-ready])').forEach(v => {
      v.dataset.axcReady = '1';
      v.muted = true; v.loop = true; v.playsInline = true;
      const btn = v.closest('section') && v.closest('section').querySelector('[data-axc-toggle]');
      const sync = () => { if (btn) { btn.classList.toggle('is-paused', v.paused); btn.setAttribute('aria-label', v.paused ? 'Play film' : 'Pause film'); } };
      v.addEventListener('play', sync); v.addEventListener('pause', sync);
      if (btn) btn.addEventListener('click', () => { if (v.paused) { v.dataset.userPaused = ''; v.play(); } else { v.dataset.userPaused = '1'; v.pause(); } });
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
      if (vio) vio.observe(v);
      sync();
    });
  }

  /* menu */
  let lastFocus = null;
  const menu = () => document.getElementById('axh-menu');
  function openMenu() {
    const m = menu(); if (!m) return;
    lastFocus = document.activeElement; m.hidden = false; document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-axh-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const f = m.querySelector('a, button'); if (f) f.focus();
  }
  function closeMenu() {
    const m = menu(); if (!m || m.hidden) return;
    m.hidden = true; document.body.style.overflow = '';
    document.querySelectorAll('[data-axh-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', e => {
    if (e.target.closest('[data-axh-menu-open]')) { openMenu(); return; }
    const closer = e.target.closest('[data-axh-menu-close]');
    if (closer) closeMenu();
    const top = e.target.closest('[data-axc-top]');
    if (top && document.querySelector('.axc-open')) { e.preventDefault(); closeMenu(); scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
    const nx = e.target.closest('[data-axc-next]');
    if (nx) { e.preventDefault(); const ws = wraps(); goTo(ws[ws.indexOf(nx.closest('.axh-section')) + 1]); return; }
    const a = e.target.closest('a[href^="#"]');
    if (a && a.getAttribute('href').length > 1) {
      const t = document.getElementById(a.getAttribute('href').slice(1));
      const w = t && t.closest('main > .axh-section');
      if (w) { e.preventDefault(); closeMenu(); goTo(w); }
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

  function init() {
    buildLists(); letters(); preload(); reveal(); collectParallax(); setTops(); films(); headerState(); kick();
  }
  addEventListener('scroll', () => { kick(); headerState(); }, { passive: true });
  addEventListener('resize', () => { setTops(); kick(); });
  addEventListener('load', () => { setTops(); kick(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme Editor: rebuild after sections are added, changed, removed or reordered */
  const later = () => setTimeout(init, 50);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(ev => document.addEventListener(ev, later));
  document.addEventListener('shopify:section:select', e => {
    const w = e.target.closest && e.target.closest('main > .axh-section');
    e.target.querySelectorAll('[data-axh-reveal]').forEach(el => el.classList.add('is-in'));
    if (w) goTo(w);
  });
})();
